import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultation-form',
  templateUrl: './consultation-form.component.html',
  styleUrls: ['./consultation-form.component.scss']
})
export class ConsultationFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
